import React, { useEffect, useRef, useImperativeHandle, forwardRef, useCallback } from 'react';
import classnames from 'classnames';
import FJHorizontalScroller from '../FJScroller/FJHorizontalScroller';
import ArrowIcon from '../../../assets/svg/catalog-right.svg?react';
import Style from './FJHorizontalScrollArrow.module.less';

import FJLocalStore from '../../../store/FJLocalStore';

const FJHorizontalScrollArrow = (props, ref) => {
    const scroll = useRef();
    const tab = useRef();

    const leftButton = useRef();
    const rightButton = useRef();
    const currentTag = FJLocalStore.currentTag();

    const {
        dataList = [],
        selectedIndex = 0,
        arrowClass,
        className,
        children,
        leftButtonStyle,
        rightButtonStyle,
        updateList,
    } = props;

    useImperativeHandle(ref, () => {
        return {
            autoLocation: _autoLocation,
            updateArrowState: _updateArrowState,
            moveScroller: _moveScroller,
            scroller: scroll.current,
        };
    });
    useEffect(() => {
        setTimeout(() => {
            // 避免有些动画过程导致箭头状态不准确
            _updateArrowState();
        }, 0);
    }, [updateList]);
    useEffect(() => {
        // 语言切换时，更新箭头状态
        _updateArrowState();
    }, [currentTag]);

    useEffect(() => {
        _autoLocation();
    }, [selectedIndex, dataList]);

    /**
     * @desc 自动定位到选中的元素上，并居中显示
     * @private
     */
    const _autoLocation = () => {
        if (tab.current && scroll.current) {
            const selectedItemRect = tab.current.getSelectedItemRect();
            if (!selectedItemRect) return;
            const scroller = scroll.current.getScroller();
            const scrollerVisibleWidth = scroller.offsetWidth;
            const scrollWidth = scroller.scrollWidth;
            const { x = 0, width = 0 } = selectedItemRect;
            let centerPoint = x + width / 2 - scrollerVisibleWidth / 2;
            if (centerPoint < 0) centerPoint = 0;
            else if (centerPoint > scrollWidth - scrollerVisibleWidth) centerPoint = scrollWidth - scrollerVisibleWidth;
            scroll.current.scrollToLeft(centerPoint, 'smooth');
        }
    };

    const _updateArrowState = useCallback(() => {
        if (!scroll.current) return;
        const scroller = scroll.current.getScroller();
        const scrollLeft = scroller.scrollLeft;
        const scrollWidth = scroller.scrollWidth;
        const visibleWidth = scroller.offsetWidth;
        const maxScrollLeft = scrollWidth - visibleWidth;

        _displayLeftButton(scrollLeft > 5);
        _displayRightButton(scrollLeft < maxScrollLeft - 5);
    }, []);

    const _displayLeftButton = display => {
        if (leftButton.current) {
            leftButton.current.style.display = display ? 'flex' : 'none';
        }
    };

    const _displayRightButton = display => {
        if (rightButton.current) {
            rightButton.current.style.display = display ? 'flex' : 'none';
        }
    };

    const _moveScroller = direction => {
        if (!scroll.current) return;
        const scroller = scroll.current.getScroller();
        const scrollLeft = scroller.scrollLeft;
        const position = direction === 'left' ? scrollLeft - 200 : scrollLeft + 200;
        scroll.current.scrollToLeft(position, 'smooth');
    };
    const cn = classnames(Style.container, className);
    return (
        <div className={cn}>
            <FJHorizontalScroller ref={scroll} className={Style.scroller} onScroll={_updateArrowState}>
                {children}
            </FJHorizontalScroller>
            <div
                ref={leftButton}
                className={classnames(Style.arrow_button, Style.left_arrow, arrowClass)}
                onClick={e => _moveScroller('left')}
                style={leftButtonStyle}
            >
                <ArrowIcon />
            </div>
            <div
                ref={rightButton}
                className={classnames(Style.arrow_button, Style.right_arrow, arrowClass)}
                onClick={e => _moveScroller('right')}
                style={rightButtonStyle}
            >
                <ArrowIcon />
            </div>
        </div>
    );
};

export default forwardRef(FJHorizontalScrollArrow);
